import FJUtil from '../../../util/FJUtil';
import $ from 'jquery';
import FJBase from './FJBase';
import FJDomUtil from '../../../util/FJDomUtil';
import FJColorUtil from '../../../util/FJColorUtil';

class FJShadow extends FJBase {
    constructor(props) {
        super(props);

        props = props || {};
        this._name = 'FJShadow';
        this._offset = typeof props.offset != 'undefined' ? props.offset : 10; // 阴影偏移距离，比例值
        this._angle = typeof props.angle != 'undefined' ? props.angle : 45; // 阴影偏移角度
        this._blur = typeof props.blur != 'undefined' ? props.blur : 20; // 阴影模糊半径，比例值
        this._color = (props && props.color) || '#f00000'; // 阴影颜色
        this._opacity = (props && props.opacity) || 100; // 阴影透明度

        this._textColor = (props && props.textColor) || ''; // 文字颜色

        this._position = (props && props.position) || 'absolute';
    }

    encode() {
        return {
            name: this._name,
            offset: this._offset,
            angle: this._angle,
            blur: this._blur,
            color: this._color,
            textColor: this._textColor,
            opacity: this._opacity,
        };
    }
    decode(data) {
        this._offset = data.offset;
        this._angle = data.angle;
        this._blur = data.blur;
        this._color = data.color;
        this._textColor = data.textColor;
        this._opacity = data.opacity;
    }
    clone() {
        let object = new FJShadow();
        object.decode(this);

        return object;
    }

    get name() {
        return this._name;
    }

    set blur(blur) {
        this._blur = blur;
    }
    get blur() {
        return this._blur;
    }

    set color(color) {
        this._color = color;
    }
    get color() {
        return this._color;
    }

    set opacity(opacity) {
        this._opacity = opacity;
    }

    get opacity() {
        return this._opacity;
    }

    /**
     * 更新文字某一行文字样式
     * @param styleData
     * @param lineIdx
     */
    updateStyle(styleData, lineIdx) {
        if (!this._layer) return;

        let lineLayers = this.getLineLayers();

        let fontSize = parseFloat(styleData.fontSize) * (styleData.contentScale ? styleData.contentScale : 1);
        let ref = (fontSize * this.offset) / 100;
        let x = ref * Math.cos((this.angle / 180) * Math.PI);
        let y = ref * Math.sin((this.angle / 180) * Math.PI);
        let blur = (fontSize * this.blur) / 100;
        if (lineIdx < lineLayers.length) {
            let ele = lineLayers[lineIdx];
            if (this._textColor) {
                $(ele).css({
                    ...styleData,
                    color: this._textColor,
                });
            } else {
                $(ele).css(styleData);
            }
        }

        let rgbaColor = FJColorUtil.hexToRgba(this._color, this._opacity);

        $(this._layer).css({
            textShadow: x + 'px ' + y + 'px ' + blur + 'px ' + rgbaColor.rgba,
        });
    }

    /**
     * @desc 更新所有行文字文字样式
     * @param styleData
     */
    updateAllLineStyle(styleData) {
        if (!this._layer) return;

        let lineLayers = this.getLineLayers();

        let fontSize = parseFloat(styleData.fontSize) * (styleData.contentScale ? styleData.contentScale : 1);
        let ref = (fontSize * this.offset) / 100;
        let x = ref * Math.cos((this.angle / 180) * Math.PI);
        let y = ref * Math.sin((this.angle / 180) * Math.PI);
        let blur = (fontSize * this.blur) / 100;
        for (let i = 0; i < lineLayers.length; i++) {
            let ele = lineLayers[i];
            if (this._textColor) {
                $(ele).css({
                    ...styleData,
                    color: this._textColor,
                });
                FJDomUtil.updateSpanTextNodeColor(ele, this._textColor);
            } else {
                $(ele).css(styleData);
            }
        }

        let rgbaColor = FJColorUtil.hexToRgba(this._color, this._opacity);

        $(this._layer).css({
            textShadow: x + 'px ' + y + 'px ' + blur + 'px ' + rgbaColor.rgba,
        });
    }

    isEqual(style) {
        let ret = true;

        ret &= this._offset === style.offset;
        ret &= this._angle === style.angle;
        ret &= this._blur === style.blur;
        ret &= this._color === style.color;

        return ret;
    }

    clear() {
        if (this._layer && this._layer.parentNode) {
            this._layer.parentNode.removeChild(this._layer);
        }
    }
}

export default FJShadow;
